var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96843 15.8276L9.82747 15.0298H9.77751C9.27968 15.6377 8.47137 16 7.5096 16C5.91439 16 4.99902 14.8835 4.99902 13.6834C4.99902 11.7135 6.80122 10.7555 9.62049 10.7625V10.6527C9.62049 10.2068 9.40458 9.52406 8.12163 9.52754C7.33474 9.52754 6.50858 9.78358 5.98042 10.0988L5.55396 8.68278C6.11959 8.35881 7.16701 8 8.51954 8C11.0926 8 11.8759 9.52232 11.8759 11.2745V13.9795C11.8759 14.6954 11.9134 15.3834 11.999 15.8293H9.96843V15.8276ZM9.68651 12.1541C8.35717 12.1437 7.22767 12.4398 7.22767 13.4518C7.22767 14.1206 7.67733 14.4428 8.26081 14.4428C8.9353 14.4428 9.46525 14.0109 9.63833 13.4918C9.67759 13.3647 9.68829 13.2149 9.68829 13.079V12.1541H9.68651Z",
    fill: "#472177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 6.14192C16.0019 6.77516 15.6119 7.28034 14.9814 7.28034C14.3847 7.28034 13.9961 6.77516 13.9991 6.14192C13.9947 5.4929 14.3949 5 14.999 5C15.609 5 15.9917 5.4894 15.999 6.14192ZM14.0694 16V8.28895H15.9257V16H14.0694Z",
    fill: "#472177"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 2.5,
    stroke: "#8D4DC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.0756792f0d8edb7b080a4a1dc22821e9.svg";
export { ForwardRef as ReactComponent };